/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  UpdateTradingChallengeOptions,
  UpdateTradingChallengeStatus200,
  UpdateTradingChallengeStatus400,
  UpdateTradingChallengeStatus403,
  UpdateTradingChallengeStatus404,
  UpdateTradingChallengeStatus409,
  UpdateTradingChallengeStatus500,
} from '../types/UpdateTradingChallenge'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { updateTradingChallenge } from '../clients/updateTradingChallenge'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const updateTradingChallengeMutationKey = () =>
  [{ url: '/v1/trading_challenges/:trading_challenge_id' }] as const

export function updateTradingChallengeMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = updateTradingChallengeMutationKey()
  return mutationOptions<
    UpdateTradingChallengeStatus200,
    ResponseErrorConfig<
      | UpdateTradingChallengeStatus400
      | UpdateTradingChallengeStatus403
      | UpdateTradingChallengeStatus404
      | UpdateTradingChallengeStatus409
      | UpdateTradingChallengeStatus500
    >,
    UpdateTradingChallengeOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ path, body }) => {
      return updateTradingChallenge({ ...config, path, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Partially update a trading challenge: a field that is absent from the body is left unchanged. Which fields may be updated depends on the challenge status. PENDING accepts every field. ACTIVE accepts only name, max_users, end and the three prize quantities, because participants are already funded and being measured. COMPLETED accepts none. A request that touches a field the current status does not allow is rejected as a whole with 409. ADMIN may update any challenge, INTEGRATOR only challenges of its own tenant, and COMPETITION_MANAGER only assigned challenge IDs.
 * @summary Update a trading challenge
 * {@link /v1/trading_challenges/:trading_challenge_id}
 */
export function useUpdateTradingChallenge<TContext>(
  options: {
    mutation?: UseMutationOptions<
      UpdateTradingChallengeStatus200,
      ResponseErrorConfig<
        | UpdateTradingChallengeStatus400
        | UpdateTradingChallengeStatus403
        | UpdateTradingChallengeStatus404
        | UpdateTradingChallengeStatus409
        | UpdateTradingChallengeStatus500
      >,
      UpdateTradingChallengeOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? updateTradingChallengeMutationKey()

  const baseOptions = updateTradingChallengeMutationOptions(config) as UseMutationOptions<
    UpdateTradingChallengeStatus200,
    ResponseErrorConfig<
      | UpdateTradingChallengeStatus400
      | UpdateTradingChallengeStatus403
      | UpdateTradingChallengeStatus404
      | UpdateTradingChallengeStatus409
      | UpdateTradingChallengeStatus500
    >,
    UpdateTradingChallengeOptions,
    TContext
  >

  return useMutation<
    UpdateTradingChallengeStatus200,
    ResponseErrorConfig<
      | UpdateTradingChallengeStatus400
      | UpdateTradingChallengeStatus403
      | UpdateTradingChallengeStatus404
      | UpdateTradingChallengeStatus409
      | UpdateTradingChallengeStatus500
    >,
    UpdateTradingChallengeOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    UpdateTradingChallengeStatus200,
    ResponseErrorConfig<
      | UpdateTradingChallengeStatus400
      | UpdateTradingChallengeStatus403
      | UpdateTradingChallengeStatus404
      | UpdateTradingChallengeStatus409
      | UpdateTradingChallengeStatus500
    >,
    UpdateTradingChallengeOptions,
    TContext
  >
}
